import { FeathersModel } from './feathersModel'
import { Assistance } from './assistance'
import { Client } from './client'
import { EjsTimepickerUtils } from '../shared/utils/EjsTimepickerUtils/EjsTimepickerUtils'

export class AssistanceTemplate extends FeathersModel {
  static serviceName = 'assistance-templates'
  private TAG = 'AssistanceTemplate'

  clientId: number
  client: Client
  preferredGenderId: number
  shortDescription: string
  detailedDescription: string
  plannedTimeFrom: string
  plannedTimeTo: string
  addressStart: string
  addressEnd: string
  needsStrongAssistant: boolean
  needsAdvancedAssistant: boolean
  nonClientWork: boolean
  coordinatorNote: string
  isSleepover: boolean = false
  isShowInExchange?: boolean = false

  public updateAssistance(assistance: Assistance) {
    console.log(this.TAG, 'updateAssistance', assistance)
    assistance.client = this.client
    assistance.clientId = this.clientId
    assistance.keyCoordinator = this.client && this.client.keyCoordinator ? this.client.keyCoordinator : undefined
    assistance.keyCoordinatorId = Number(this.client.keyCoordinatorId)
    assistance.preferredAssistantGenderId = this.preferredGenderId
    assistance.shortDescription = this.shortDescription
    assistance.detailedDescription = this.detailedDescription
    assistance.plannedTimeFrom = this.plannedTimeFrom
    assistance.plannedTimeTo = this.plannedTimeTo
    assistance.addressStart = this.addressStart
    assistance.addressEnd = this.addressEnd
    assistance.strongAssistantNeeded = this.needsStrongAssistant
    assistance.advancedAssistantNeeded = this.needsAdvancedAssistant
    assistance.nonClientWork = this.nonClientWork
    assistance.coordinatorNote = this.coordinatorNote
    assistance.isSleepover = this.isSleepover
    assistance.isShowInExchange = this.isShowInExchange
  }

  public updateFromAssistance(assistance: Assistance): AssistanceTemplate {
    this.clientId = assistance.clientId
    this.client = assistance.client
    this.preferredGenderId = assistance.preferredAssistantGenderId
    this.shortDescription = assistance.shortDescription
    this.detailedDescription = assistance.detailedDescription
    this.plannedTimeFrom = EjsTimepickerUtils.ensureStringTimeHHdelimMMFormat(assistance.getDateFrom())
    this.plannedTimeTo = EjsTimepickerUtils.ensureStringTimeHHdelimMMFormat(assistance.getDateTo())
    this.addressStart = assistance.addressStart
    this.addressEnd = assistance.addressEnd
    this.needsStrongAssistant = assistance.strongAssistantNeeded
    this.needsAdvancedAssistant = assistance.advancedAssistantNeeded
    this.nonClientWork = assistance.nonClientWork
    this.coordinatorNote = assistance.coordinatorNote
    this.isSleepover = assistance.isSleepover
    this.isShowInExchange = assistance.isShowInExchange

    return this
  }

  hasAllRequiredFields() {
    return !!(
      this.clientId &&
      this.shortDescription &&
      this.detailedDescription &&
      this.plannedTimeFrom &&
      this.plannedTimeTo &&
      this.addressStart &&
      this.addressEnd
    )
  }
}
